import { render } from "./BillNotesChat.vue?vue&type=template&id=660c09ec"
import script from "./BillNotesChat.vue?vue&type=script&lang=js"
export * from "./BillNotesChat.vue?vue&type=script&lang=js"

import "./BillNotesChat.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__